(function () {
    'use strict';

    /**
     * @ngdoc factory
     * @name manageFlights.factory:ManageFlightsRequestFactory
     *
     * @description
     *
     */
    angular
        .module('flightCargo')
        .factory('FlightCargoFactory', FlightCargoFactory);

    function FlightCargoFactory() {

        function SearchFlightCargoRequest() {
        	this.flightNumber = null;
            this.departure = null;
            this.arrival = null;
            this.fromDate = null;
            this.toDate = null;
            this.cargoWeightAvailable = null;
            this.pageSize = null;
            this.startPosition = null;
        }

        function UpdateFlightCargoRequest() {
        	this.flightLegId = null;
            this.cargoWeight = null;
        }

        var searchFlightCargoRQ = function (searchParams) {
            var searchFlightCargo = new SearchFlightCargoRequest();
            searchFlightCargo.flightNumber = searchParams.flightNumber;
            searchFlightCargo.arrival = angular.isUndefined(searchParams.arrival.value) || searchParams.arrival.value === null ? null : searchParams.arrival.value.airPortCode;
            searchFlightCargo.departure = angular.isUndefined(searchParams.departure.value) || searchParams.departure.value === null ? null : searchParams.departure.value.airPortCode;
            searchFlightCargo.fromDate = searchParams.fromDate;
            searchFlightCargo.toDate = searchParams.toDate;
            searchFlightCargo.cargoWeightAvailable = searchParams.cargoWeightAvailable;
            searchFlightCargo.pageSize = searchParams.pageSize;
            searchFlightCargo.startPosition = searchParams.startPosition;
            return searchFlightCargo;
        };

        var updateFlightCargoRQ = function (updateParams) {
        	var cargoList = {flightCargoDTOS : []};
        	angular.forEach(updateParams.flightCargoDTOS, function(flight){
        		 var updateCargoWeight = new UpdateFlightCargoRequest();
                 updateCargoWeight.flightLegId = flight.flightLegId;
                 updateCargoWeight.cargoWeight = flight.cargoWeight;
                 cargoList.flightCargoDTOS.push(updateCargoWeight);
        	})
        	return cargoList;
        };

        var getFormattedFlights = function (flightCargoData) {
        	angular.forEach(flightCargoData.flightCargoDTOs, function(flight){
        		if(flight.cargoWeight != undefined && flight.cargoWeight != null) {
        			flight.cargoWeight = parseFloat(flight.cargoWeight);
        		}
        	})
        	return flightCargoData;
        };

        return{
        	searchFlightCargoRQ : searchFlightCargoRQ,
        	updateFlightCargoRQ : updateFlightCargoRQ,
        	getFormattedFlights : getFormattedFlights,
        }
    }
})();
